<template>
	<div>
		<article class="iv2-article" v-if="pageActive">
			<LayoutTitle :title="title" :subtitle="subtitle" />
			<LayoutPattern :coupon="coupon" />
			<LayoutModal :coupon="coupon" />
		</article>
		<div v-if="loading">
			<BaseLoading />
		</div>
	</div>
</template>

<script>
import LayoutTitle from "./components/LayoutTitle.vue";
import LayoutPattern from "./components/LayoutPattern.vue";
import LayoutModal from "./components/LayoutModal.vue";
import BaseLoading from "@/components/items/BaseLoading.vue";

import Meta from "@/mixins/MetaSettable";
import Preview from "@/mixins/Preview";

export default {
	mixins: [Meta, Preview],

	props: ["animation"],

	components: {
		LayoutTitle,
		LayoutPattern,
		LayoutModal,
		BaseLoading,
	},

	data() {
		return {
			coupon: [],
			title: "",
			subtitle: "",
			pageActive: false,
			loading: true,
		};
	},

	mounted() {
		const id = this.$route.params.id

		if(this.$route.query.mode == 'preview') {
			this.axios.get("/preview/coupons", {
				headers: {
					Authorization: `Bearer ${this.$cookies.get('preview-token')}`,
				}
			}).then(({data}) => {
				this.title = data.response.title;
				this.subtitle = data.response.subtitle;
			});
			this.axios.get("/preview/coupons/" + id + "/show", {
				headers: {
					Authorization: `Bearer ${this.$cookies.get('preview-token')}`,
				}
			}).then((response) => {
				this.coupon = response.data.response;
				this.loading = false;
				this.pageActive = true;
			}).catch(() => {
				this.loading = false;
				this.pageActive = true;
			});
		}else{
			this.axios.get("/coupons").then(({data}) => {
				this.title = data.response.title;
				this.subtitle = data.response.subtitle;
			});
			this.axios.get("/coupons/" + id + "/show").then((response) => {
				this.coupon = response.data.response;
				this.loading = false;
				this.pageActive = true;
			}).catch(() => {
				this.loading = false;
				this.pageActive = true;
			});
		}
	},
};
</script>

<style lang="scss">
</style>
